<template>
  <div class="box">
    <div class="box1">
      <div class="boxleft">
        <!-- 图片 -->
        <img src="../assets/img/icon4.svg" style="height:276px;width:438px;margin-left:114px;margin-top:51px;margin-bottom:49px;"/>
      </div>
      <div class="boxright">
        <p>Lenovo P12 Pro <br />Android 13 Developer <br />Preview Program</p>
        <p class="boxp">Great news！Our build is available.</p>
      </div>
    </div>
    <div class="box2">
      <div class="boxcontent">
        <h2 style="padding-top: 40px">What’s new</h2>
        <ul>
          <p class="box4p">
            Android 13 is optimized for large screens, with features to improve
            multi-tasking, compatibility support, <br />system UI optimizations, and
            more.
          </p>
          <li>Security patch updated to Jun.2022.</li>
          <li>Android 13 Beta2 image is available.</li>
        </ul>
        <p>
          Plan ahead and proactively ready your apps for the official market
          release of Android 13.
        </p>
        <p class="gray" style="margin-top: 20px; padding-bottom: 34px">
          Your valued feedback through the Feedback app will also help us
          deliver a better Lenovo Android tablet <br />
          experience in the future.
        </p>
      </div>
      <img src="../assets/img/logo13.svg" style="height:282px;width:282px"/>
    </div>
    <div class="box3">
      <div class="boxcontent">
        <h2 style="padding-top: 40px">Important Notes</h2>
        <p class="box4p">
          Please review the points below before proceeding with the registration process:
        </p>
        <div style="margin-right: 52px">
          <ul>
            <li>
              Android 13 developer preview builds are early Android OS releases and
              are intended for application developers only – they are not recommended for general use.
            </li>
            <li>
              Although strenuously tested by our development team, the builds 
              may display performance and/or stability issues in some instances.
            </li>
            <li>
              Some applications downloaded from the Google Play Store may not 
              be supported (either in full or partially) and may behave erratically.
            </li>
            <li>
              Online support is limited and may not be available to help users 
              who experience difficulties with flashing the device.
            </li>
            <li>
              The Beta image is not the final version, and some features might 
              be missing or not working well.
            </li>
          </ul>
        </div>
        <p class="te">
          If you have any concerns on whether these builds are suitable for your use, 
          we recommend you do not continue with developer preview registration and 
          wait for the official market release.
        </p>
        <p class="gray" style="margin-top: 20px; padding-bottom: 25px">
          <span>Note:</span>Please note, we may not be able to offer Android developer 
          preview builds to devices on certain network providers.
        </p>
      </div>
    </div>
    <div class="box4">
      <div class="boxcontent">
        <h2 style="padding-top: 40px">Ready to get started?</h2>
        <div style="width: 933px">
          <p class="box4p">
            Please double check P12 Pro device on your hand is WIFI version and
            purchased from the markets outside of China, as now the provided
            image only support the WIFI devices which are on sale outside of
            China. Wrong device usage will cause device bricked. Several ways to
            identify WIFI device:
          </p>
          <ul style="margin-left: 5px">
            <li>Check the sales box.</li>
            <li>
              The card slot in the left edge has only one holder for SD card.
            </li>
            <li>
              Go to &lt;System&gt; in &lt;Settings&gt; on your device, the Model
              name in &lt;About tablet&gt; is "Lenovo TB-Q706F".
            </li>
          </ul>
          <p class="box4p">
            Please remember that software flashing will result in the loss of
            user data, we recommend that you backup your personal data properly
            before a software flashing.
          </p>
          <ul class="box4ul">
            <li>
              &nbsp;1. Download
              <a
                href="https://ota-cdn.lenovo.com/firmware/2022511184231138-2767.zip"
                >SW flashing packages</a
              >
              and install & configure your PC environment by following the
              instruction <b>inside the package.</b>
            </li>
            <li>
              &nbsp;2. Download and unzip
              <a
                href="https://ota-cdn.lenovo.com/firmware/2022718141817592-8679.zip"
                >13 Beta2 image</a
              >
              on your local drive, and then flash your device following the
              corresponding instruction in SW flashing packages.
            </li>
          </ul>
        </div>
        <li style="list-style-type: none">
          Now your device should be ready. Please visit the
          <a
            href="https://developer.android.com/about/versions/13"
            target="_blank"
            >13 developer site</a
          >
          for details on how to set up your environment in Android Studio.
        </li>
        <h3>SW limitation</h3>
        <div style="margin-right: 52px">
          <p>
          To serve a stable system SW to support your development as quick as possible, 
          some functions on P12 Pro official SW are tailored, please check the details below.
          </p>
          <ul class="box4ul2">
            <li>Fingerprint unlock is not supported.</li>
            <li>Face Unlock is not supported.</li>
            <li>TOF sensor related function is removed.</li>
            <li>Stylus key function is not supported but basic function works.</li>
            <li>Touchpad functions with two fingers are not supported.</li>
            <li>Touchpad swipe up/down/left/right with 3 or 4 fingers are not supported.</li>
            <li>Miracast function is not supported.</li>
            <li>Screen output via cable (extended screen) can be supported when
               &lt;force desktop mode&gt; is turned on in developer menu.</li>
            <li>Cast Via HDMI (extended screen) can be supported when
               &lt;force desktop mode&gt; is turned on in developer menu.</li>
            <li>VPN is not tested and may not work properly.</li>
            <li>WIDI is not supported.</li>
            <li>Video play may face audio issue.</li>
            <li>Settings may display abnormal sometimes, re-selecting or 
              cleaning recent apps can make it work properly.</li>
          </ul>
          <h3>Key notes</h3>
          <ul style="margin-left: 2px; padding-bottom: 25px">
            <li>
              Please manually connect keyboard to your device via bluetooth to
              display battery info of keyboard in Settings.
            </li>
            <li>
              Please report issue/question via preload Feedback apk on your
              device if any. The more details you provided, the faster we can
              support you an effective suggestion.
            </li>
          </ul>
        </div>
      </div>
      <img src="../assets/img/icon3.svg" />
    </div>
    <div class="box5">
      <div class="boxcontent5">
        <h2 style="padding-top: 40px">Rollback to official release</h2>
        <p>
          We really hope you'll continue with the Android developer preview of
          13 and share your feedback, but if you'd prefer to return to the
          official release software, you can do so by requesting a rollback
          through this tool.
          <br /><a
            href=" https://support.lenovo.com/us/en/downloads/ds101291"
            target="_blank"
            >https://support.lenovo.com/us/en/downloads/ds101291</a
          ><br />
          This tool currently only supports WIFI device which is on sale outside
          of China markets.
        </p>
        <p>Advisory notice:</p>
        <ul style="padding-bottom: 25px">
          <li>
            Please remember that rollback to an official market release will
            result in the loss of user data. We recommend that you periodically
            backup any important data such as contacts, call logs, pictures,
            videos, music, installed apps, chat history, SMS history, notes,
            etc. You may also need to re-install any applications previously
            downloaded.
          </li>
          <li>
            Ideally, your device should be fully charged, but a minimum of 60%
            charge is recommended.
          </li>
          <li>
            Please note you will not be able use the device – including any
            attempts to make an emergency call – until the installation is
            complete and the device has booted into a stable state.
          </li>
          <li>The tool currently only supports Windows OS.</li>
        </ul>
      </div>
    </div>
    <p class="gray" style="padding-bottom: 15px">Update 15 Jul 2022</p>
  </div>
</template>
<script>
export default {};
</script>

<style scoped>

.box {
  width: 1342px;
  /* width: 90% !important; */
  margin: 0 auto;
}
.box1 {
  height: 376px;
  background: #ffffff;
  border-radius: 28px;
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
}
.box1 img {
  width: 582px;
  height: 381px;
  margin-top: 45px;
  margin-left: 5px;
}
.boxright {
  width: 700px;
  margin-top: 86px;
  /* margin-left: 119.63px; */
}
.boxright p {
  font-size: 52px;
  color: #181818;
  margin: 0;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 900;
  line-height: 52px;
  margin-bottom: 30px;
}
.boxright .boxp {
  font-family: Lato;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 16px;
  color: #181818;
}
.box .box2 {
  height: 364px;
  background: #ffffff;
  border-radius: 28px;
  margin-top: 32px;
  margin-bottom: 32px;
  position: relative;
}
.boxcontent {
  margin-left: 42px;
}
.boxcontent5 {
  margin-left: 52px;
  margin-right: 52px;
}
.h2 {
  font-family: Lato;
  font-style: normal;
  font-weight: 900;
  font-size: 22px;
  line-height: 28px;
  color: #000000;
  padding-top: 40px;
}
.box ul li {
  list-style-type: disc;
  margin-left: 20px;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #000000;
}
.gray {
  color: #999;
  font-size: 16px;
  line-height: 24px;
  font-family: Lato;
  font-style: normal;
}
.box2 img {
  width: 282px;
  height: 159px;
  position: absolute;
  right: 37px;
  top: 50%;
  transform: translateY(-50%);
}
.box .box3 {
  background: #ffffff;
  border-radius: 28px;
  margin-bottom: 32px;
  height: 412px;
  position: relative;
}
.box3 ul {
  margin-right: 52px;
}
.gray span {
  font-family: Lato;
  font-style: normal;
  color: #999;
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
}
.box .te {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #000000;
  margin-top: -1px;
  margin-right: 52px;
}
.box4 {
  background: #ffffff;
  border-radius: 28px;
  margin-bottom: 32px;
  padding-right: 65px;
  position: relative;
}
.box4 img {
  position: absolute;
  width: 172px;
  height: 172px;
  right: 82px;
  top: 40px;
}
.box4 h3 {
  font-family: Lato;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #000000;
  margin-top: 30px;
  margin-bottom: 20px;
}
.box5 {
  background: #ffffff;
  border-radius: 28px;
  margin-bottom: 32px;
  position: relative;
}
.circle {
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 2px solid #181818;
  box-sizing: border-box;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  font-family: Lato;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  color: #000000 !important;
  margin-right: 17px;
}
.box4 .box4ul li {
  /* list-style: none; */
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #000000;
}
.box4 ul {
  margin-left: -18px;
  margin-bottom: 30px;
}
.box4 .box4ul2 li {
  list-style: disc;
  margin-left: 40px;
}
.box5 p {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
}
.box4p {
  font-family: Lato;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #000000;
  margin-bottom: 30px;
}
a {
  color: #0000ee;
}

</style>